// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1VxG0","container":"styles_container__2sYI5","title":"styles_title__1Nv8N","wrapper":"styles_wrapper__15yzM","answer":"styles_answer__1mvV2"};